import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import QuickTixLogo from "../../../../../../Images/GX_Logo_Black_No_Bg.png";

import QrCode from "../../../../../../Images/qrCode1.png";
import moment from "moment";
function Ticket6({ ticket, ChangeColor, type, image, bookerName, navigator }) {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Box sx={{ height: "100%" }}>
      <Grid
        elevation={0}
        sx={{
          height: "100%",
          display: "flex",
          border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
          boxShadow: pevSelected
            ? "0 4px 12px rgba(74, 144, 226, 0.5)"
            : "0 2px 8px rgba(0, 0, 0, 0.1)",
          transition: "all 0.1s ease",
          "&:hover": {
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
            border: "1px solid #4A90E2",
            borderRadius: "1px",
          },
          backgroundColor: ChangeColor
            ? ChangeColor
            : ticket?.bgColor
            ? ticket?.bgColor
            : "white",
          justifyContent: "space-around",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Stack
            alignItems={"center"}
            direction={"row"}
            flex={1}
            justifyContent={"center"}
          >
            <Stack
              flex={1}
              direction={"column"}
              justifyContent={"space-between"}
              height={"80%"}
              alignItems={"center"}
              gap={"0.3rem"}
            >
              <Stack
                variant="h6"
                Wrap
                component="div"
                sx={{
                  fontWeight: "bold",
                  fontSize: {
                    xs: "0.7rem",
                  },
                  color: "#191919",
                  writingMode: "vertical-rl",
                  transform: "rotate(180deg)",
                  fontFamily: "lato",
                  padding: 0,
                  margin: 0,
                }}
              >
                {ticket?.time}
              </Stack>
              <Stack
                variant="h6"
                Wrap
                component="div"
                sx={{
                  fontWeight: "bold",
                  fontSize: {
                    xs: "0.7rem",
                  },
                  color: "#191919",
                  writingMode: "vertical-rl",
                  transform: "rotate(180deg)",
                  fontFamily: "lato",
                  padding: 0,
                  margin: 0,
                }}
              >
                {moment(ticket?.date).format("MM/DD/YYYY")}
              </Stack>
            </Stack>
            <Stack
              flex={1}
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: "2rem",
                  sm: "2rem",
                  md: "2rem",
                  lg: "3rem",
                },
                color: "#191919",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                fontFamily: "Bebas Neue",
                padding: 0,
                margin: 0,
              }}
              textAlign={"center"}
            >
              {/* {type ? type : "VIP"} */}
              {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
            </Stack>
          </Stack>
          <Stack
            flex={1}
            variant="h6"
            Wrap
            component="div"
            sx={{
              alignItems: "end",
              fontWeight: "bold",
              fontSize: "1rem",
              whiteSpace: "nowrap",
              color: "#191919",
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              fontFamily: "Bebas Neue",
              padding: 0,
              marginY: 3,
            }}
            textAlign={"center"}
          >
            ${" "}
            {ticket?.price != null && ticket?.price !== ""
              ? ticket?.ticketPrices
                ? Object.values(ticket?.ticketPrices)[0]
                : Number(ticket?.price) === 0
                ? "Free"
                : Number(ticket?.price) % 1 === 0
                ? Number(ticket?.price).toFixed(0)
                : ticket.price
              : "211"}
          </Stack>
        </Box>
        <Stack
          direction={"column"}
          flex={1}
          sx={{
            borderLeft: "3px dotted black",
            borderRight: "3px dotted black",
          }}
        >
          <Stack
            display={"flex"}
            direction={"row"}
            justifyContent={"center"}
            mt={3}
            pb={1}
          >
            <img
              crossOrigin="anonymous"
              src={image ? image : QuickTixLogo}
              alt="QR"
              style={{
                width: "40%",
                maxHeight: "80px",
                maxWidth: "80%",
                height: "auto",
                objectFit: "contain",
                marginLeft: "2%",
              }}
            />
          </Stack>
          <Stack display={"flex"} direction={"row"} justifyContent={"center"}>
            <Typography
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: 600,
                fontSize: {
                  xs: "0.55rem",
                  sm: "0.8rem",
                  md: "1rem",
                  // lg: "1rem",
                },
                color: "black",
                fontFamily: "Lato",
              }}
            >
              {bookerName}
            </Typography>
          </Stack>
          <Stack display={"flex"} direction={"row"} justifyContent={"center"}>
            <Typography
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: 400,
                fontSize: {
                  xs: "1.1rem",
                  sm: "1.8rem",
                  md: "1.8rem",
                  // lg: "1rem",
                },
                color: "black",
                fontFamily: "Bangers",
              }}
            >
              {ticket?.title}
            </Typography>
          </Stack>
          <Stack display={"flex"} direction={"row"} justifyContent={"center"}>
            <Typography
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: 400,
                fontSize: {
                  xs: "0.6rem",
                  sm: "0.65rem",
                  md: "0.7rem",
                  // lg: "1rem",
                },
                color: "black",
                fontFamily: "lato",
                textAlign: "center",
              }}
            >
              {ticket?.ticketName ? ticket?.ticketName : "Ticket"}
            </Typography>
          </Stack>
          <Stack
            display={"flex"}
            direction={"row"}
            justifyContent={"center"}
            mt={3}
            pb={1}
          >
            <Typography
              variant="h6"
              Wrap
              component="div"
              sx={{
                fontWeight: 400,
                fontSize: {
                  xs: "0.6rem",
                  sm: "0.8rem",
                  md: "0.9rem",
                  // lg: "1rem",
                },
                color: "black",
                fontFamily: "lato",
                textAlign: "center",
              }}
            >
              {ticket?.location}
            </Typography>
          </Stack>
        </Stack>
        <Box
          alignItems={"center"}
          sx={{ display: "flex", flexDirection: "row" }}
          flex={1}
          justifyContent={"center"}
          position={"relative"}
          gap={{ xs: "0.2em", sm: "0.7em" }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: {
                xs: "0.6rem",
                sm: "0.875rem",

                color: "#191919",
                fontFamily: "Lato",
                writingMode: "vertical-rl", // Rotates the text vertically
                transform: "rotate(180deg)", // Rotates the text to read from top to bottom
              },
            }}
            //   mt={4}
          >
            {ticket?.code}
          </Typography>
          <Stack ml={2} mt={1}>
            <Box>
              {navigator === "ct" ? (
                <></>
              ) : !qrCodeData ? (
                <img
                  src={QrCode}
                  alt="qr"
                  style={{
                    width: "100%",
                    maxWidth: "80%",
                    height: "auto",
                    maxHeight: "100px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={ticket?.qrCode || QrCode}
                  alt="QR"
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "auto",
                    maxHeight: "100px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>
            <Box sx={{ position: "absolute", bottom: 4 }}>
              <img
                alt="Logo"
                src={QuickTixLogo}
                style={{
                  width: "100%",
                  maxWidth: "80%",
                  height: "auto",
                  maxHeight: "30px",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Stack>
        </Box>
      </Grid>
    </Box>
  );
}

export default Ticket6;
